import script from "./edit.vue?vue&type=script&setup=true&lang=ts"
export * from "./edit.vue?vue&type=script&setup=true&lang=ts"

import "./edit.vue?vue&type=style&index=0&id=256a9cfd&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-256a9cfd"]])

export default __exports__